export default selectedGender =>
  ({ staff }) => {
    if (selectedGender.value === null) {
      return true;
    }

    return staff.gender === selectedGender.value;
  };
